import './ArtistModal.scss';

import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useArtistContext } from '../ArtistPageContext';

export default function HighlightsModal({ show, handleClose, onSave }) {
  const { artist, setArtist } = useArtistContext();
  const [spotifyHighlight, setSpotifyHighlight] = useState("");
  const [youTubeHighlight, setYouTubeHighlight] = useState("");

  useEffect(() => {
    setSpotifyHighlight(artist.spotify_highlight);
    setYouTubeHighlight(artist.youtube_highlight);
  }, [artist, show]);

  const handleSave = async () => {
    const updatedData = { spotify_highlight: spotifyHighlight, youtube_highlight: youTubeHighlight };
    setArtist(prev => ({ ...prev, ...updatedData }));
    if (onSave) onSave(updatedData);
    handleClose();
  };

  return (
    <Modal className='__artist-modal' show={ show } onHide={ handleClose } centered>
      <Modal.Header closeButton>
        <Modal.Title>Add Spotify and YouTube highlights</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="modal-subtitle">
          Show everyone what you're capable of!
        </div>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Spotify Link</Form.Label>
            <Form.Control
              value={ spotifyHighlight }
              onChange={ (e) => setSpotifyHighlight(e.target.value) }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>YouTube Link</Form.Label>
            <Form.Control
              value={ youTubeHighlight }
              onChange={ (e) => setYouTubeHighlight(e.target.value) }
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button className="ppy-btn ppy-btn-tertiary" onClick={ handleClose }>Cancel</Button>
        <Button className="ppy-btn ppy-btn-primary" onClick={ handleSave }>Save</Button>
      </Modal.Footer>
    </Modal>
  );
}
